module.exports = __webpack_public_path__ + "static/media/flota.f980d2af.svg";